import React from 'react';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-[#c9a84c] font-display font-bold text-xl mb-3">{title}</h2>
    <div className="text-[#9a9890] text-sm leading-relaxed space-y-3">{children}</div>
  </div>
);

export const Privacidad = () => (
  <div className="min-h-screen" style={{ background: '#050508', color: '#e8e6e0' }}>
    <nav className="px-6 md:px-12 py-5 flex items-center gap-3 border-b border-white/5">
      <Link to="/" className="flex items-center gap-3 group">
        <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: '#0d0d10', border: '1.5px solid rgba(201,168,76,0.3)' }}>
          <svg viewBox="0 0 40 40" width="24" height="24" fill="none">
            <polygon points="20,5 4,18 36,18" fill="#f0c040"/>
            <rect x="26" y="8" width="4" height="8" fill="#f0c040"/>
            <rect x="7" y="18" width="26" height="17" fill="#f0c040"/>
            <rect x="15" y="25" width="10" height="10" fill="#050508" rx="1"/>
            <circle cx="23" cy="30" r="1" fill="#c9a84c"/>
            <rect x="9" y="20" width="7" height="6" fill="#050508" rx="1"/>
            <rect x="24" y="20" width="7" height="6" fill="#050508" rx="1"/>
          </svg>
        </div>
        <span className="font-display font-bold text-white tracking-tight">E-<span className="text-[#c9a84c]">HOME</span></span>
      </Link>
    </nav>

    <main className="max-w-3xl mx-auto px-6 py-16">
      <div className="mb-12">
        <p className="text-[#c9a84c] text-xs font-semibold uppercase tracking-widest mb-3">Legal</p>
        <h1 className="font-display font-black text-4xl md:text-5xl text-white mb-4">Política de Privacidad</h1>
        <p className="text-[#7a7870] text-sm">Última actualización: 25 de abril de 2026</p>
      </div>

      <Section title="1. Responsable del tratamiento">
        <p>El responsable del tratamiento de los datos personales recogidos a través de la plataforma E-HOME es <strong className="text-white">IaConsultora S.L.</strong>, con domicilio en España, y contacto disponible en <a href="mailto:info@iaconsultora.com" className="text-[#c9a84c] hover:underline">info@iaconsultora.com</a>.</p>
      </Section>

      <Section title="2. Datos que recopilamos">
        <p>Recopilamos los datos que nos proporcionas directamente al registrarte: nombre, dirección de correo electrónico, número de teléfono (opcional) y datos de perfil profesional. También recopilamos datos de uso de la plataforma con fines de mejora del servicio.</p>
      </Section>

      <Section title="3. Finalidad del tratamiento">
        <ul className="list-disc list-inside space-y-1">
          <li>Prestación y mantenimiento del servicio E-HOME.</li>
          <li>Gestión de tu cuenta y suscripción.</li>
          <li>Comunicaciones relacionadas con el servicio.</li>
          <li>Mejora de funcionalidades y análisis estadístico agregado.</li>
          <li>Cumplimiento de obligaciones legales.</li>
        </ul>
      </Section>

      <Section title="4. Base legal">
        <p>El tratamiento se basa en la ejecución del contrato de prestación de servicios (art. 6.1.b RGPD) y, para comunicaciones comerciales, en el consentimiento explícito del usuario (art. 6.1.a RGPD).</p>
      </Section>

      <Section title="5. Conservación de los datos">
        <p>Los datos se conservan durante la vigencia de la relación contractual y, posteriormente, durante los plazos legalmente exigidos (máximo 5 años para datos fiscales).</p>
      </Section>

      <Section title="6. Cesión de datos">
        <p>No cedemos tus datos a terceros, salvo obligación legal o proveedores de servicios técnicos (hosting, pagos) vinculados por acuerdos de tratamiento encargado y bajo las mismas garantías de seguridad.</p>
      </Section>

      <Section title="7. Tus derechos">
        <p>Puedes ejercer en cualquier momento los derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición escribiendo a <a href="mailto:info@iaconsultora.com" className="text-[#c9a84c] hover:underline">info@iaconsultora.com</a>. También puedes reclamar ante la Agencia Española de Protección de Datos (www.aepd.es).</p>
      </Section>

      <Section title="8. Seguridad">
        <p>Aplicamos medidas técnicas y organizativas adecuadas para proteger tus datos frente a accesos no autorizados, pérdida o destrucción, incluyendo cifrado en tránsito (HTTPS/TLS) y en reposo.</p>
      </Section>

      <Section title="9. Cambios en esta política">
        <p>Nos reservamos el derecho a actualizar esta política. Te notificaremos cualquier cambio relevante por correo electrónico o mediante aviso destacado en la plataforma.</p>
      </Section>
    </main>

    <footer className="border-t border-white/5 px-6 py-8 text-center">
      <p className="text-[#7a7870] text-xs">© 2026 ehomesp.com · <Link to="/privacidad" className="hover:text-[#c9a84c] transition-colors">Privacidad</Link> · <Link to="/cookies" className="hover:text-[#c9a84c] transition-colors">Cookies</Link> · <Link to="/contacto" className="hover:text-[#c9a84c] transition-colors">Contacto</Link></p>
    </footer>
  </div>
);

export default Privacidad;
